import { render } from "./ProsesSPM.vue?vue&type=template&id=764bac0c"
import script from "./ProsesSPM.vue?vue&type=script&lang=js"
export * from "./ProsesSPM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__